<template>
  <div class="content-with-spacing">
    <div class="help-title-container">
      <span class="help-title-icon"><i class="fas fa-book-open-cover" aria-hidden="true"></i></span>
      <h1 class="help-title">Help</h1>
    </div>
    <section class="help-cards-container">
      <div class="col-md-6 col-sm-6 col-xs-12">
        <div class="panel panel-default">
          <div class="panel-heading">
            <h2 class="panel-title">Advanced KATE Setup</h2>
          </div>
          <div class="panel-body">
            <p class="description">
              This is for advanced users who want to use git to submit on KATE.
            </p>
            <div class="panel-footer">
              <router-link :to="{ name: 'help_advanced_setup'}">
                Read More<i class="fas fa-angle-right" aria-hidden="true"></i>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-12">
        <div class="panel panel-default">
          <div class="panel-heading">
            <h2 class="panel-title">Logging OTJ Hours in EDUKATE</h2>
          </div>
          <div class="panel-body">
            <p class="description">
              How to log your Off-The-Job (OTJ) hours in EDUKATE.
            </p>
            <div class="panel-footer">
              <router-link :to="{ name: 'help_otj_guidance'}">
                Read More<i class="fas fa-angle-right" aria-hidden="true"></i>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-12">
        <div class="panel panel-default">
          <div class="panel-heading">
            <h2 class="panel-title">Meetings Guidance</h2>
          </div>
          <div class="panel-body">
            <p class="description">
              Guidance on preparing for and logging meetings.
            </p>
            <div class="panel-footer">
              <router-link :to="{ name: 'help_meetings_guidance'}">
                Read More<i class="fas fa-angle-right" aria-hidden="true"></i>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-12">
        <div class="panel panel-default">
          <div class="panel-heading">
            <h2 class="panel-title">Project Tracker Guidance</h2>
          </div>
          <div class="panel-body">
            <p class="description">
              Guidance on using the Project Tracker.
            </p>
            <div class="panel-footer">
              <router-link :to="{ name: 'help_project_tracker_guidance'}">
                Read More<i class="fas fa-angle-right" aria-hidden="true"></i>
              </router-link>
            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
.help-cards-container {
  margin-top: 20px;
}

.help-title-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin: 35px 0;
}

.help-title-container h1 {
  text-align: center;
}

.help-title-icon {
  background-color: var(--kate-button-primary);
  padding: 10px;
  border-radius: 20%;
}

.help-title-container i {
  font-size: 2em;
}

.description {
  min-height: 60px;
}

.help-cards-container .panel-heading {
  padding: 30px 15px;
}

.panel-footer {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
}

.panel-footer a {
  width: fit-content;
  border-top: 1px solid var(--kate-background-alt);
  border-radius: 0;
  padding: 15px 0;
  margin-top: 15px;
  text-decoration: none;
}

.panel-footer-labels {
  display: flex;
  gap: 10px;
}
</style>

<script>
import StorageMixin from '@mixins/storage-mixins';

export default {

  mixins: [StorageMixin],

  mounted() {
    this.$logger.pageReady();
    this.$Loading.finish();
  },
};
</script>
